<template>
  <div class="advertisement">
    <h3 class="advertisement_title">广告</h3>
    <div>
      <DeliverySettings :delivery_settings="advertisement.deliverySettings" />
    </div>
  </div>
</template>

<script>
import DeliverySettings from './deliverySettings.vue'
export default {
  components: {
    DeliverySettings
  },
  props: {
    advertisement: {
      type: Object,
      default() {
        return {

        }
      }
    }
  },
  data() {
    return {

    }
  },
  created() {

  }
}
</script>

<style lang="less" scoped>
.advertisement{
  width: 90%;
  margin: 0 auto;

  .advertisement_title{
    font-size: 25px;
    font-weight: bold;
    margin-bottom: 20px;
  }
}
</style>
